import React, {Component} from 'react';
import {css} from 'emotion';

import '../appComponents/accordion-styles.css';

const styles ={
    title: css`
        ${tw`w-full flex items-center py-5 px-6 justify-between`};
        font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
        font-weight: 600;
        font-size: 1rem;
        @media(min-width: 992px){
            font-size: 1.0625rem;
        }
        color: #F5F5F7;
        letter-spacing: -0.01em;
        background: #1A1A24;
        border: 1px solid rgba(170, 11, 202, 0.2);
        border-radius: 6px 6px 0 0;
        margin-bottom: 0;
        border-bottom: none;
    `,
    body: css`
        ${tw`flex-wrap w-full flex`};
        background: #111118;
        border: 1px solid rgba(170, 11, 202, 0.2);
        border-top: none;
        border-radius: 0 0 6px 6px;
        margin-bottom: 0.625rem;
        color: #F5F5F7;
    `,
}
/* global tw*/
class AccordionItem extends Component{
    render(){
        return(
            <div className={css`${tw`flex w-full flex-wrap`}` + ' accordion-item' }>
                <div className={styles.title + ' accordion-title'}>
                    <p>{this.props.title}</p>
                </div>
                <div className={styles.body}>
                    {this.props.children}
                </div>
            </div>
        );
    }
}


export default AccordionItem;

AccordionItem.defaultProps = {
    title: 'Default Title'
}
